/**
 * Route-to-label map for the ControlCambios module.
 * Keys are pathname prefixes (longest first wins).
 * Values are human-readable Spanish labels used as the `modulo` field in reports.
 */
export const ROUTE_LABELS = {
  // Control de Cambios (new — must appear before /control-cambios parent)
  '/control-cambios/mis-reportes': 'Mis Reportes de Cambios',
  '/control-cambios': 'Control de Cambios',

  // Cotizaciones (longest prefixes first)
  '/marker-rates/dashboard': 'Dashboard Cotizaciones',
  '/marker-rates/briefcase': 'Unidades de Negocio',
  '/save-marker-rates': 'Editar Cotización',
  '/marker-rates/settings/status': 'Estados de Cotización',
  '/marker-rates': 'Cotizaciones',

  // Proyectos
  '/projects/activities': 'Actividades de Proyectos',
  '/projects': 'Proyectos',

  // Visitas
  '/project': 'Visita de Proyecto',

  // Financiero / Siigo
  '/financiero/dashboard': 'Dashboard Financiero',

  // Ventas
  '/ventas/crm': 'CRM',
  '/ventas/competidores': 'Competidores',
  '/ventas/contratos': 'Contratos',

  // Configuración
  '/configuracion/refrigerante/listado': 'Refrigerantes',
  '/configuracion/causa-raiz': 'Causa Raíz',
  '/config-site': 'Configuración del Sitio',
  '/config/feedback': 'Feedback',
  '/settings/measures': 'Unidades de Medida',

  // Contabilidad / Inventario
  '/accountant/warehouse': 'Bodega',
  '/accountant/orders-materials': 'Materiales por Orden',
  '/accountant/tool-order': 'Asignación de Herramientas',
  '/accountant/materials': 'Materiales',
  '/accountant/tools': 'Herramientas',
  '/accountant': 'Contabilidad',

  // Reportes
  '/report/maintenances': 'Reporte de Mantenimientos',
  '/report/minor-box': 'Caja Menor',
  '/report/root-cause': 'Causa Raíz',
  '/report': 'Reportes',

  // Clientes / Subsidiarias
  '/customer': 'Clientes',
  '/customers': 'Clientes',
  '/subsidiary': 'Sucursales',

  // Órdenes
  '/order-list': 'Órdenes',
  '/order-calendar': 'Calendario de Órdenes',
  '/my-orders': 'Mis Órdenes',
  '/order-types': 'Tipos de Orden',

  // Monitoreo
  '/users/monitoring': 'Monitoreo de Usuarios',
  '/monitoring/report-location': 'Reporte de Ubicación',

  // Equipos / Mantenimiento
  '/my-equipments': 'Mis Equipos',
  '/my-maintenance': 'Mis Mantenimientos',
  '/maintenance-plan': 'Plan de Mantenimiento',
  '/schedule-plans': 'Planes de Agendamiento',
  '/equipment-types': 'Tipos de Equipo',

  // Roadmap / Diseño
  '/roadmaps': 'Roadmaps',
  '/design': 'Diseño',

  // Puestos / Usuarios / Políticas
  '/job-positions': 'Puestos de Trabajo',
  '/category-user': 'Categorías de Usuario',
  '/policy': 'Políticas',
  '/user': 'Usuarios',

  // Dashboard
  '/dashboard-ejecutivo': 'Dashboard Ejecutivo',

  // Facturación
  '/billing': 'Facturación',
};

/**
 * Returns the human-readable label for the given pathname.
 * Sorts keys by length descending so the most specific prefix wins.
 * Falls back to 'App' when no prefix matches.
 *
 * @param {string} pathname - e.g. window.location.pathname
 * @returns {string}
 */
export function getRouteLabel(pathname) {
  const keys = Object.keys(ROUTE_LABELS).sort((a, b) => b.length - a.length);
  const match = keys.find((k) => pathname.startsWith(k));
  return match ? ROUTE_LABELS[match] : 'App';
}

/**
 * Alias used by FeedbackButton (design §3.3 calls it detectModulo).
 * Identical behaviour to getRouteLabel.
 */
export const detectModulo = getRouteLabel;
